import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/* eslint-disable i18next/no-literal-string -- CSS class constants, not user-visible strings */
/** Positions a search/filter icon inside a relative-positioned input wrapper. */
export const searchIconClass = 'absolute left-2 top-2.5 h-4 w-4 text-muted-foreground'

/** Inline badge with a leading icon — keeps badge and icon on one line at natural width. */
export const badgeWithIconClass = 'flex items-center gap-1 w-fit'
/* eslint-enable i18next/no-literal-string */
